<template>
  <div class="form-item">
    <div class="label" v-show="label" :style="usWidth">{{ label }}</div>
    <slot class="box"></slot>
  </div>
</template>

<script>
export default {
  props: ['label'],
  computed: {
    usWidth() {
      if (window._language == 'en-us') {
        return 'width : 170px';
      } else {
        return "width : ''";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.form-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  // border-bottom: 1px solid #eee;
  .label {
    // width: 170px;
    margin-right: 15px;
  }
}
</style>
